import { Card, CardBody, Typography } from '@material-tailwind/react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Container from '../components/Container'
import { useSessionContext } from '../contexts/SessionContext'
import { useFeatureAuth } from '../hooks/authorization'
import { usePageTitle } from '../hooks/toolkit'
import { FEATURES } from '../utils/constants/features.constants'
import { useAgamiRoutes } from '../hooks/useAgamiRoutes'

const Upload = () => {
  const { t } = useTranslation()
  usePageTitle('Upload | Agami')

  const { loading } = useSessionContext()

  const navigate = useNavigate()
  const { newAgamiPath } = useAgamiRoutes()
  const newSpotPath = newAgamiPath()

  const uploadSpotAuth = useFeatureAuth(FEATURES.UPLOAD_SPOTS_UI)

  const experienceEditorAuth = useFeatureAuth(FEATURES.EXP_EDITOR_UI)

  // if use can't create experiences, redirect to single spot upload
  useEffect(() => {
    if (loading) return
    if (!experienceEditorAuth) navigate(newSpotPath, { replace: true })
  }, [loading, experienceEditorAuth, navigate, newSpotPath])

  return (
    <Container direction="col">
      <Typography variant="h1" className="text-primary dark:text-base-gray-400" data-testid="upload-title">
        {t('upload.newContentTitle')}
      </Typography>

      <div className="w-full mt-10 grid grid-cols-1 md:grid-cols-2 gap-4">
        {uploadSpotAuth && (
          <Card
            className="cursor-pointer hover:bg-base-gray-500 dark:hover:bg-primary-300"
            onClick={() => navigate(newSpotPath)}
            data-testid="upload-single-agami-card"
          >
            <CardBody>
              <Typography variant="h5">{t('upload.uploadAgamiTitle')}</Typography>
              <Typography>{t('upload.uploadAgamiDescription')}</Typography>
            </CardBody>
          </Card>
        )}

        {experienceEditorAuth && (
          <Card
            className="cursor-pointer hover:bg-base-gray-500 dark:hover:bg-primary-300"
            onClick={() => navigate('/upload/experience')}
            data-testid="upload-experience-card"
          >
            <CardBody>
              <Typography variant="h5">{t('upload.createExperienceTitle')}</Typography>
              <Typography>{t('upload.createExperienceDescription')}</Typography>
            </CardBody>
          </Card>
        )}
      </div>
    </Container>
  )
}

export default Upload
